import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'pointsChangeReceipt:loading-label': {
    id: 'pointsChangeReceipt:loading-label',
    defaultMessage: 'Fetching Receipt...',
    description: 'Points change Receipt: Loading text',
  },
});
